import type { Opportunity } from './opportunity';
import type { Signal } from './signal';
import type { SiteTrend } from './siteTrend';

export type Insight = SiteTrend | Opportunity | Signal;

export const MAX_EMAILS_COUNT = 10;

export const MAX_EMAILS_TO_REGENERATE = 5;

export const SAM_AVAILABLE_LANGUAGES = [
  { id: 'en', text: 'English' },
  { id: 'de', text: 'German' },
  { id: 'it', text: 'Italian' },
  { id: 'nl', text: 'Dutch' },
  { id: 'fr', text: 'French' },
  { id: 'es', text: 'Spanish' },
];
